import React, { useEffect, useState } from 'react';

interface Option {
  key: string;
  label: string;
}

interface ToggleSelectProps {
  options: Option[];
  activeOption: string;
  onSwitch: (optionKey: string) => void;
  /** additional class for outer container */
  className?: string;
  /** optional className to override button padding/text size */
  buttonClassName?: string;
  [key: string]: any;
}

const ToggleSelect: React.FC<ToggleSelectProps> = ({
  options,
  activeOption,
  onSwitch,
  className = '',
  buttonClassName = '',
  ...props
}) => {
  const [selectedIndex, setSelectedIndex] = useState(
    options.findIndex((option) => option.key === activeOption),
  );

  // Update the selected index when the active option changes
  useEffect(() => {
    setSelectedIndex(options.findIndex((option) => option.key === activeOption));
  }, [activeOption, options]);

  return (
    <div
      className={`relative flex bg-surface_gray_50 border border-border_gray_200 rounded-full p-1 ${className}`}
      {...props}
    >
      <div
        className='absolute top-1 left-1 bottom-1 bg-primary rounded-full transition-transform duration-300 ease-in-out'
        style={{
          width: `calc((100% - 8px) / ${options.length})`,
          transform: `translateX(${selectedIndex * 100}%)`,
        }}
      />

      {options.map((option, index) => (
        <button
          key={option.key}
          className={`relative z-10 flex-1 text-center font-medium rounded-full transition-colors duration-300 
          ${buttonClassName || 'px-4 py-2 text-sm'}
          ${activeOption === option.key ? 'text-text_contrast' : 'text-text_gray_800 opacity-75 hover:opacity-100'}`}
          onClick={() => onSwitch(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleSelect;
